import React, { useState } from "react";
import "./css/FAQs.css";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  // Hardcoded Donation-Related FAQs based on Veer Samyak Foundation's mission
  const faqs = [
    {
      id: 1,
      question: "How does my donation help children in transition?",
      answer: "Your contributions provide more than just shelter; they offer a foundation of dignity. Funds are used to ensure absolute security, nutritional meals, healthcare, and a loving home environment for children as they move toward a stable future."
    },
    {
      id: 2,
      question: "Can I donate in honor of a loved one or a spiritual milestone?",
      answer: "Yes. In the spirit of 'Seva,' many of our patrons choose to celebrate birthdays, anniversaries, or spiritual milestones by donating. We can provide a digital acknowledgment to honor the person or occasion."
    },
    {
      id: 3,
      question: "Where exactly is my money being spent?",
      answer: "Transparency is core to our conviction. Donations are channeled directly into our human welfare programs—ranging from maintaining our transit homes to providing emergency outreach for families with nowhere else to turn."
    },
    {
      id: 4,
      question: "Are my donations tax-exempt?",
      answer: "Veer Samyak Foundation is a registered entity. Most donations are eligible for tax benefits under Section 80G of the Income Tax Act. You will receive a formal donation receipt via email for your records."
    },
    {
      id: 5,
      question: "Can I contribute through monthly recurring donations?",
      answer: "Absolutely. Building hope beyond limits requires consistent effort. You can set up a monthly contribution to provide the 'quiet, steady impact' that allows us to plan long-term welfare projects for those in need."
    }
  ];

  return (
    <section className="faqs-section">
      <div className="customcontainer">
        <div className="faqs-main">
          <h2 className="faq-title" data-aos="fade-up">
            Frequently Asked Questions
          </h2>

          <div className="faq-list" data-aos="fade-up">
            {faqs.map((item, index) => {
              const isOpen = activeIndex === index;

              return (
                <div key={item.id} className="faq-item">
                  <button
                    className="faq-question"
                    onClick={() =>
                      setActiveIndex(isOpen ? null : index)
                    }
                  >
                    <span>{item.question}</span>

                    <motion.span
                      className="faq-icon"
                      animate={{ rotate: isOpen ? 180 : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                          fill="#ddd5c7"
                        />
                      </svg>
                    </motion.span>
                  </button>

                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        className="faq-answer"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{
                          duration: 0.4,
                          ease: "easeInOut",
                        }}
                      >
                        <p>{item.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
